import React from 'react';
import { themes } from './theme';

const ThemeContext = React.createContext(themes.light);

export default ThemeContext;
